<div class="dashboard-header">
  <h1 class="dashboard-title">Welcome to the Platform Dashboard</h1>
  <p class="dashboard-subtitle">Select a module to get started</p>
</div>
<div class="dashboard-grid fancy-dashboard-grid">
  <div class="dashboard-tile fancy-tile" *ngFor="let item of filteredItems">
    <a [routerLink]="item.routerLink" class="dashboard-tile-link">
      <div class="dashboard-tile-img-wrapper">
        <img class="dashboard-tile-img" [src]="getImage(item.image)" [alt]="item.title1" />
        <div class="dashboard-tile-gradient"></div>
      </div>
      <div class="dashboard-tile-content fancy-tile-content">
        <span class="dashboard-tile-title">{{ item.title1 }}</span>
        <span class="dashboard-tile-arrow">→</span>
      </div>
    </a>
  </div>
</div>
